import type { NexReconciliationIdentifierMode } from './invoiceNexIdentifierUi';
import { resolveNexRoContactId } from './resolveNexSubmitReference';

/** True when both-mode Key Identifiers should show explicit PO and RO fields. */
export function hasExplicitBothModePoRo(args: {
    mode: NexReconciliationIdentifierMode | undefined;
    purchaseOrderNumber?: string | null;
    shopRoNumber?: string | null;
}): boolean {
    if (args.mode !== 'both') return false;
    const po = String(args.purchaseOrderNumber ?? '').trim();
    const ro = String(args.shopRoNumber ?? '').trim();
    return po.length > 0 && ro.length > 0 && po !== ro;
}

/** NEX refresh is allowed when any lookup candidate is present. */
export function canRefreshNexsyisForInvoice(args: {
    roNumber?: string | null;
    purchaseOrderNumber?: string | null;
    shopRoNumber?: string | null;
}): boolean {
    return [args.roNumber, args.purchaseOrderNumber, args.shopRoNumber].some(
        (v) => String(v ?? '').trim().length > 0,
    );
}

/** Both-mode PO refresh (`po_first`) needs a purchase order reference. */
export function canRefreshPoNexsyisForInvoice(args: {
    mode?: NexReconciliationIdentifierMode | undefined;
    roNumber?: string | null;
    purchaseOrderNumber?: string | null;
}): boolean {
    const mode = args.mode ?? 'ro';
    if (mode === 'ro') {
        return String(args.roNumber ?? '').trim().length > 0;
    }
    return (
        String(args.purchaseOrderNumber ?? '').trim().length > 0 ||
        String(args.roNumber ?? '').trim().length > 0
    );
}

/** Both-mode RO refresh (`ro_only`) needs a shop repair-order folder, not the PO id alone. */
export function canRefreshRoNexsyisForInvoice(args: {
    mode?: NexReconciliationIdentifierMode | undefined;
    roNumber?: string | null;
    purchaseOrderNumber?: string | null;
    shopRoNumber?: string | null;
}): boolean {
    return Boolean(
        resolveNexRoContactId({
            mode: args.mode,
            roNumber: args.roNumber,
            purchaseOrderNumber: args.purchaseOrderNumber,
            shopRoNumber: args.shopRoNumber,
        }),
    );
}
